import { render, staticRenderFns } from "./uniqueDialog.vue?vue&type=template&id=3136ca1e&scoped=true"
import script from "./uniqueDialog.vue?vue&type=script&lang=js"
export * from "./uniqueDialog.vue?vue&type=script&lang=js"
import style0 from "./uniqueDialog.vue?vue&type=style&index=0&id=3136ca1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136ca1e",
  null
  
)

export default component.exports